<script setup lang="ts"></script>

<template>
  <a
    href="https://x.com/jup_mobile/status/1887728177985839245"
    target="_blank"
    class="w-full flex gap-4 flex-row bg-brand-background p-4 rounded-jup border-[1px] border-[#00E6CF]/50"
  >
    <img src="/speaker.svg" alt="Winners" width="20" height="19" />
    <div>
      <p
        class="bg-gradient-to-r from-[#00BCF0] to-[#C7F284] inline-block font-semibold text-transparent bg-clip-text"
      >
        Winners Selected for Invite Contest!
      </p>
      <p class="font-medium">Click here to see the winners!</p>
    </div>
  </a>
</template>
